// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.experiment-diagnostics__running-icon--running {
  color: #ffbf00;
}
.experiment-diagnostics__running-icon--idle {
  color: #cccccc;
}
.experiment-diagnostics__running-icon--unknown {
  color: #f98890;
}
.experiment-diagnostics--compact {
  position: relative;
}
.experiment-diagnostics--compact .experiment-diagnostics__running-icon {
  position: absolute;
  top: -25%;
  right: -25%;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/components/experiment-id/experiment-state-icon/apply-status-color.less","webpack://./src/neptune-app/components/experiment-id/experiment-state-icon/ExperimentDiagnostics.less"],"names":[],"mappings":"AAKE;EACE,cAAA;ACJJ;ADME;EACE,cAAA;ACJJ;ADME;EACE,cAAA;ACJJ;AADE;EACE,kBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAEJ","sourcesContent":["@status-running: #ffbf00;\n@status-idle: #cccccc;\n@red-strawberry: #f98890;\n\n.apply-status-color() {\n  &--running {\n    color: @status-running;\n  }\n  &--idle {\n    color: @status-idle;\n  }\n  &--unknown {\n    color: @red-strawberry;\n  }\n}\n","@import './apply-status-color';\n\n.experiment-diagnostics {\n  &__running-icon {\n    .apply-status-color();\n  }\n\n  &--compact {\n    position: relative;\n  }\n\n  &--compact &__running-icon {\n    position: absolute;\n    top: -25%;\n    right: -25%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
